export const hotkeyAction = {
    TOGGLE_GLOBAL_SEARCH_SLASH: "TOGGLE_GLOBAL_SEARCH_SLASH",
    TOGGLE_GLOBAL_SEARCH_ALT_SPACE: "TOGGLE_GLOBAL_SEARCH_ALT_SPACE",
    RESULT_GO_UP: "RESULT_GO_UP",
    RESULT_GO_DOWN: "RESULT_GO_DOWN",
    ENTER_RESULT: "ENTER_RESULT",
};

export const hotkeyToAction = {
    "/": hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH,
    "alt+space": hotkeyAction.TOGGLE_GLOBAL_SEARCH_ALT_SPACE,
    up: hotkeyAction.RESULT_GO_UP,
    down: hotkeyAction.RESULT_GO_DOWN,
    enter: hotkeyAction.ENTER_RESULT,
};

export const actionToHotkey = {
    [hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH]: { hotkeyLabel: "/", eventCheck: e => e.code === "Slash" },
    [hotkeyAction.TOGGLE_GLOBAL_SEARCH_ALT_SPACE]: {
        hotkeyLabel: "alt+space",
        eventCheck: e => e.altKey && e.code === "Space",
    },
    [hotkeyAction.RESULT_GO_UP]: {hotkeyLabel: "up", eventCheck: e => e.code === "ArrowUp" },
    [hotkeyAction.RESULT_GO_DOWN]: {hotkeyLabel: "down", eventCheck: e => e.code === "ArrowDown" },
    [hotkeyAction.ENTER_RESULT]: {hotkeyLabel: "enter", eventCheck: e => e.code === "Enter" },
};

/**
 * used in keynames prop
 * @param {String[]} keys array of hotkeyAction strings
 * @returns comma separated string of hotkeyLabel (eg: "/,alt+space,enter")
 */
export const getKeysString = keys => keys.map(k => actionToHotkey[k].hotkeyLabel).join();

/**
 * Used in ReactHotkeys filter prop: To stop the keyboard event propagation when hotkeys are pressed.
 * eg: '/' is used to open/close. when focused on input, '/' should not add extra input
 * @param {KeyboardEvent} e
 * @param {String[]} filteredKeys
 * @returns {boolean} true if the current keyboard event is one of the hotkeys
 */
export const isCurrentEventAHotkey = (e, filteredKeys) => filteredKeys.some(k => {
    if (actionToHotkey[k])
        return actionToHotkey[k].eventCheck(e);
    return false;
});
